import { React, useState, useEffect, useContext } from "react";
import { AppContext } from '../../../../AppStore';
import styled from "styled-components";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import GridNoRow from '../../../../common/GridNoRow';
import axios from "axios";
import Swal from "sweetalert2";
import Moment from 'moment';
import Button from "@mui/material/Button";
import "moment/locale/ko";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useNavigate, useLocation } from "react-router-dom";

const MachineProductionLog = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const appStore = useContext(AppContext);
    const [MenuID, setMenuID] = useState(0);
    const [MenuName, setMenuName] = useState('');
    const [MenuUpdateExistYN, setMenuUpdateExistYN] = useState('N');
    const [MenuDeleteExistYN, setMenuDeleteExistYN] = useState('N');
    const [MenuUpdateYN, setMenuUpdateYN] = useState('N');
    const [MenuDeleteYN, setMenuDeleteYN] = useState('N');
    const [tabID, setTabID] = useState('');
    const [machineOption, setMachineOption] = useState([]);
    const [rows, setRows] = useState();
    const [columns, setColumns] = useState([]);
    const [logRows, setLogRows] = useState();
    const [logColumns, setLogColumns] = useState([]);
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({
        id: false,
        status: true,
        gijun_date: false,
        hardware_id: false,
        program_running_start_datetime: true,
        program_running_end_datetime: true,
        machine_id: false,
        machine_name: true,
        machine_data_yn: false
    });
    const [logColumnVisibilityModel, setLogColumnVisibilityModel] = useState({
        id: false,
        machine_name: false,
        gijun_date: true,
        logdata: true
    });

    useEffect(() => {
        const accessList = JSON.parse(localStorage.getItem("nav"));
        
        if (Array.isArray(accessList) && accessList.filter(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).length > 0) {
            setMenuID(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_id);
            setMenuName(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_name);
            setMenuUpdateExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_exist_yn);
            setMenuDeleteExistYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_exist_yn);
            setMenuUpdateYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_update_yn);
            setMenuDeleteYN(accessList.find(item => String(item.menu_url) === String(window.location.pathname).split("/").slice(0, 3).join("/")).menu_delete_yn);
        }else{
            Swal.fire({
                title: '<p style="color:red">접근 권한 오류</p>',
                text: '화면에 접근 권한이 없습니다.',
                confirmButtonText: '확인',
                confirmButtonColor: '#7066e0',
                timer:5000,
                timerProgressBar: true
            }).then((value) => {
                return navigate(-1);
            });
        }
    }, []);

    useEffect(() => {
        if (machineOption.length > 0) {
            const first = machineOption[0];
            setTabID(String(first.value));
        } else {
            setTabID('');
        }
    }, [machineOption]);

    useEffect(() => {
        handleView();
    }, [tabID]);

    useEffect(() => {
        // 아래의 변수가 변경되면 실행된다. -> 권한체크가 되면 MenuID가 변경되므로, 권한체크 후 Grid 설정.
        if(String(MenuID) !== String(0) && MenuID != null){
            handleSetting();
            axios.get('/api/SelectCommon/MachineList')
            .then((response) => {
                const optionArray = response.data.map((item, index) => 
                    ({ value: item.machine_id, label: item.machine_name })
                );
                setMachineOption([ ...new Set((optionArray).map(JSON.stringify)) ].map(JSON.parse));
            })
            .catch((error) => {
                console.log(error);
            });
        }
    }, [MenuID])

    const handleSetting = () => {
        setColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'machine_id', headerName: 'machine_id', width: 0, headerAlign: 'center', align:'left'},
            { field: 'machine_name', headerName: '설비', width: 200, headerAlign: 'center', align:'left'},
            { field: 'status', headerName: '상태', width: 70, headerAlign: 'center', align:'center'},
            { field: 'gijun_date', headerName: '기준일시', width: 180, headerAlign: 'center', align:'center'},
            { field: 'hardware_id', headerName: '하드웨어ID', width: 350, headerAlign: 'center'},
            { field: 'program_running_start_datetime', headerName: '시작일시', width: 180, headerAlign: 'center', align:'center'},
            { field: 'program_running_end_datetime', headerName: '종료일시', width: 180, headerAlign: 'center', align:'center'},
            { field: 'machine_data_yn', headerName: '설비 Data 추가', width: 150, headerAlign: 'center', align:'center' }
        ]);
        setLogColumns([
            { field: 'id', headerName: 'id', width: 0, headerAlign: 'center' },
            { field: 'machine_name', headerName: '설비', width: 150, headerAlign: 'center', align:'left'},
            { field: 'gijun_date', headerName: '기준일시', width: 180, headerAlign: 'center', align:'center'},
            { field: 'logdata', headerName: '이벤트', width: 700, headerAlign: 'center'}
        ]);
    }

    const handleView = () => {
        if(!tabID){
            return;
        }

        if (appStore.loading) return;
        appStore.setLoading(true);

        axios.get('/api/p/MachineProductionLog/ProgramList',
            {
            params : {
                machine_id : tabID
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            var array = response.data.map((item, index) => ({
                id: index,
                machine_name: item.machine_name,
                status: '정상',
                gijun_date: item.gijun_date,
                hardware_id: item.hardware_id,
                program_running_start_datetime: item.program_running_start_datetime,
                program_running_end_datetime: item.program_running_end_datetime,
                machine_id: item.machine_id,
                machine_data_yn: item.machine_data_yn
            }));
            setRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        });

        axios.get('/api/p/MachineProductionLog/LogList',
            {
            params : {
                machine_id : tabID
            }
          },
          { withCredentials: true }
        )
        .then((response) => {
            var array = response.data.map((item, index) => ({
                id: index,
                machine_name: item.machine_name,
                gijun_date: item.gijun_date,
                logdata: item.logdata
            }));
            setLogRows([ ...new Set((array).map(JSON.stringify)) ].map(JSON.parse));
        })
        .catch((error) => {
            appStore.capture();
        })
        .finally(() => {
            appStore.setLoading(false);
        });
    };

    const handleTabID = (event, newTabID) => {
        setTabID(String(newTabID));
    };
    return (
        <div style={ { width:'100%', display: String(MenuID) === String(0) ? 'hidden' : 'block' } }>
            <div className="menubox" style={ { height: '70px', boxShadow: 'none' } }>
            <div className="menu-action" style={ { height: '55px' } }>
                <div className="menu-title">{ MenuName }</div>
            </div>
            <TabContext value={tabID || (machineOption[0] ? String(machineOption[0].value) : '')}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                        {machineOption.length > 0 && machineOption.map((item, index) => (
                            <Tab key={index} label={item.label} value={String(item.value)} />
                        ))}
                    </TabList>
                </Box>
            </TabContext>
                        
            </div>
            <div className="grid" style={ { top: '122px' } }>
                <div style={ {  width: '100%' } }>
                    {/* <div style={{ float: 'left', width: '780px' }}> */}
                    <div style={{ width: '100%' }}>
                        <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 222px)', fontSize: '17px' } }>
                            <DataGrid
                                className="grid_main"
                                rows={rows}
                                columns={columns}
                                slots={{
                                    noRowsOverlay: GridNoRow,
                                }}
                                columnVisibilityModel={columnVisibilityModel}
                                AlternatingRowBackground="LavenderBlush"
                                rowsPerPageOptions={[20, 50, 100]}
                            />
                        </div>
                    </div>
                    {/* 
                    <div style={{ float: 'left', width: '20px' }}>

                    </div>
                    <div style={{ float: 'right', width: 'calc(100% - 800px)' }}>
                        <div className="grid_sub" style={ { width: '100%', height: 'calc(100vh - 262px)', fontSize: '17px' } }>
                            <DataGrid
                                className="grid_main"
                                rows={logRows}
                                columns={logColumns}
                                slots={{
                                    noRowsOverlay: GridNoRow,
                                }}
                                columnVisibilityModel={logColumnVisibilityModel}
                                AlternatingRowBackground="LavenderBlush"
                                rowsPerPageOptions={[20, 50, 100]}
                            />
                        </div>
                    </div>
                    */}
                </div>
            </div>
        </div>
    )
}

const AppWrap = styled.div`
  text-align: center;
  margin: 50px auto;
`;
export default MachineProductionLog;
